import { useState } from 'react';

export default function GarageDoorFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'How much does garage door installation cost in El Paso?',
      answer: 'Garage door installation in El Paso typically costs between $800 to $3,500, depending on door type, size, material, and features. Basic single-car steel doors start around $800-$1,200, while custom wood or insulated doors for two-car garages can cost $2,000-$3,500+. Opener installation adds $200-$500. Always get multiple quotes for accurate pricing.'
    },
    {
      question: 'How long does a garage door installation take?',
      answer: 'Standard garage door installation typically takes 4-6 hours for a single door. This includes removing the old door (if applicable), installing the new door, tracks, springs, and opener. Complex installations with custom doors or additional features may take a full day. Most contractors complete residential installations in one visit.'
    },
    {
      question: 'What are the signs my garage door needs repair?',
      answer: 'Common signs include unusual noises (grinding, squeaking), slow or jerky movement, door not opening or closing completely, sagging sections, visible damage to panels or tracks, broken springs or cables, and opener malfunctions. If you notice any of these issues, contact a professional immediately for safety reasons.'
    },
    {
      question: 'How often should I maintain my garage door?',
      answer: 'Professional maintenance should be performed annually. This includes lubricating moving parts, checking spring tension, inspecting cables and rollers, testing safety features, and adjusting the opener. Monthly visual inspections and basic lubrication by homeowners help extend door lifespan and prevent costly repairs.'
    },
    {
      question: 'Can I replace just one panel of my garage door?',
      answer: 'Yes, individual panels can often be replaced if damaged, especially on sectional doors. However, matching the exact color and style may be challenging for older doors. If multiple panels are damaged or the door is over 10 years old, full replacement might be more cost-effective. Your contractor can assess the best option.'
    },
    {
      question: 'What type of garage door is best for El Paso\'s climate?',
      answer: 'Insulated steel doors are ideal for El Paso\'s extreme temperatures, providing energy efficiency and durability. They withstand intense sun and temperature fluctuations better than wood. For luxury homes, insulated steel with wood overlay offers aesthetics and performance. Proper insulation (R-value 12-18) helps regulate garage temperature year-round.'
    },
    {
      question: 'Are smart garage door openers worth it?',
      answer: 'Smart openers offer significant benefits including remote access via smartphone, real-time alerts, integration with home automation systems, and enhanced security features. They\'re especially valuable for monitoring when away from home. Prices range from $200-$500, and most can be installed on existing doors. Many homeowners find the convenience worth the investment.'
    },
    {
      question: 'How long do garage door springs last?',
      answer: 'Torsion springs typically last 10,000-20,000 cycles (7-10 years with average use). Extension springs last slightly less. High-cycle springs can last 25,000-100,000 cycles. Factors affecting lifespan include usage frequency, climate, maintenance, and spring quality. Never attempt DIY spring replacement—they\'re under extreme tension and dangerous without proper tools and training.'
    },
    {
      question: 'Do I need a permit for garage door installation in El Paso?',
      answer: 'Permits are typically not required for simple garage door replacement. However, structural modifications, new garage construction, or electrical work for openers may require permits. Your contractor should know local requirements and handle permit applications if needed. Always verify with the City of El Paso Building Department for your specific project.'
    },
    {
      question: 'What safety features should my garage door have?',
      answer: 'Essential safety features include auto-reverse sensors that stop and reverse the door if objects are detected, manual release for emergency operation, rolling code technology to prevent hacking, and pinch-resistant panel design. Modern openers should have battery backup for power outages. Ensure all safety features are tested regularly and functioning properly.'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Get answers to common questions about garage door services in El Paso
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-xl border-2 border-gray-200 overflow-hidden hover:border-teal-500 transition-all">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
              >
                <h3 className="text-lg font-bold text-gray-900 pr-4">{faq.question}</h3>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-teal-600 flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-sm text-gray-700 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
